// Curated Airaa Bold SVG icon set — fill="currentColor" so CSS color() works.
// Source: ported from Coynitt web app's layout.js. Add new icons here as needed.
import React from 'react';

const Svg = ({ size = 20, children, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    {...props}
  >
    {children}
  </svg>
);

export const Icons = {
  // 4-square grid (Overview)
  dashboard: (props) => (
    <Svg {...props}>
      <path d="M7.24 2H5.34C3.15 2 2 3.15 2 5.33V7.23C2 9.41 3.15 10.56 5.33 10.56H7.23C9.41 10.56 10.56 9.41 10.56 7.23V5.33C10.57 3.15 9.42 2 7.24 2Z" fill="currentColor" />
      <path d="M18.6695 2H16.7695C14.5895 2 13.4395 3.15 13.4395 5.33V7.23C13.4395 9.41 14.5895 10.56 16.7695 10.56H18.6695C20.8495 10.56 21.9995 9.41 21.9995 7.23V5.33C21.9995 3.15 20.8495 2 18.6695 2Z" fill="currentColor" />
      <path d="M18.6695 13.43H16.7695C14.5895 13.43 13.4395 14.58 13.4395 16.76V18.66C13.4395 20.84 14.5895 21.99 16.7695 21.99H18.6695C20.8495 21.99 21.9995 20.84 21.9995 18.66V16.76C21.9995 14.58 20.8495 13.43 18.6695 13.43Z" fill="currentColor" />
      <path d="M7.24 13.43H5.34C3.15 13.43 2 14.58 2 16.76V18.66C2 20.85 3.15 22 5.33 22H7.23C9.41 22 10.56 20.85 10.56 18.67V16.77C10.57 14.58 9.42 13.43 7.24 13.43Z" fill="currentColor" />
    </Svg>
  ),

  // Wallet — filled wallet with card slot
  wallet: (props) => (
    <Svg {...props}>
      <path d="M14.85 3.94999V7.74999H13.35V3.94999C13.35 3.67999 13.11 3.54999 12.95 3.54999C12.9 3.54999 12.85 3.55999 12.8 3.57999L4.87 6.56999C4.34 6.76999 4 7.26999 4 7.83999V8.50999C3.09 9.18999 2.5 10.28 2.5 11.51V7.83999C2.5 6.64999 3.23 5.58999 4.34 5.16999L12.28 2.16999C12.5 2.08999 12.73 2.04999 12.95 2.04999C13.95 2.04999 14.85 2.85999 14.85 3.94999Z" fill="currentColor" />
      <path d="M21.4999 14.5V15.5C21.4999 15.77 21.2899 15.99 21.0099 16H19.5499C19.0199 16 18.5399 15.61 18.4999 15.09C18.4699 14.78 18.5899 14.49 18.7899 14.29C18.9699 14.1 19.2199 14 19.4899 14H20.9999C21.2899 14.01 21.4999 14.23 21.4999 14.5Z" fill="currentColor" />
      <path d="M19.48 12.95H20.5C21.05 12.95 21.5 12.5 21.5 11.95V11.51C21.5 9.44 19.81 7.75 17.74 7.75H6.26C5.41 7.75 4.63 8.03 4 8.51C3.09 9.19 2.5 10.28 2.5 11.51V18.24C2.5 20.31 4.19 22 6.26 22H17.74C19.81 22 21.5 20.31 21.5 18.24V18.05C21.5 17.5 21.05 17.05 20.5 17.05H19.63C18.67 17.05 17.75 16.46 17.5 15.53C17.29 14.77 17.54 14.04 18.04 13.55C18.41 13.17 18.92 12.95 19.48 12.95ZM14 12.75H7C6.59 12.75 6.25 12.41 6.25 12C6.25 11.59 6.59 11.25 7 11.25H14C14.41 11.25 14.75 11.59 14.75 12C14.75 12.41 14.41 12.75 14 12.75Z" fill="currentColor" />
    </Svg>
  ),

  // Clock (Transactions)
  clock: (props) => (
    <Svg {...props}>
      <path d="M12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2ZM16.35 15.57C16.21 15.81 15.96 15.94 15.7 15.94C15.57 15.94 15.44 15.91 15.32 15.83L12.22 13.98C11.45 13.52 10.88 12.51 10.88 11.62V7.52C10.88 7.11 11.22 6.77 11.63 6.77C12.04 6.77 12.38 7.11 12.38 7.52V11.62C12.38 11.98 12.68 12.51 12.99 12.69L16.09 14.54C16.45 14.75 16.57 15.21 16.35 15.57Z" fill="currentColor" />
    </Svg>
  ),

  // Shield (Compliance) — bold filled
  shield: (props) => (
    <Svg {...props}>
      <path d="M11.0299 2.13C11.6499 1.93 12.3399 1.93 12.9599 2.13L19.4899 4.31C20.4099 4.62 21.0299 5.49 21.0299 6.45V11.27C21.0299 16.13 17.5899 20.71 12.7799 21.95C12.2799 22.07 11.7099 22.07 11.2099 21.95C6.39988 20.71 2.95988 16.13 2.95988 11.27V6.45C2.95988 5.49 3.57988 4.62 4.49988 4.31L11.0299 2.13ZM15.79 10.2C16.08 9.91 16.08 9.43 15.79 9.14C15.5 8.85 15.02 8.85 14.73 9.14L11.07 12.79L9.27 11C8.98 10.7 8.5 10.7 8.21 11C7.92 11.29 7.92 11.77 8.21 12.06L10.54 14.39C10.83 14.69 11.31 14.69 11.6 14.39L15.79 10.2Z" fill="currentColor" />
    </Svg>
  ),

  // Bell (Agent Reports / Notifications)
  bell: (props) => (
    <Svg {...props}>
      <path d="M12.0196 2.0498C15.6395 2.04991 18.5889 5 18.589 8.62988V10.5C18.589 10.9799 18.8097 11.7697 19.0597 12.1797L20.1896 14.0596C20.5996 14.7496 20.6795 15.5703 20.3995 16.3203C20.1195 17.0601 19.5297 17.6404 18.7599 17.9004C17.6799 18.2604 16.5693 18.5397 15.4493 18.7197C15.3393 18.7397 15.2292 18.7595 15.1192 18.7695C14.9393 18.7995 14.7592 18.8198 14.5792 18.8398C14.3593 18.8698 14.1294 18.8902 13.8995 18.9102C13.2796 18.9701 12.6496 19 12.0196 19C11.3797 19 10.7395 18.9702 10.1095 18.9102C9.83949 18.8902 9.57943 18.8603 9.31944 18.8203C9.16944 18.8003 9.01901 18.7798 8.87901 18.7598C8.76931 18.7398 8.65961 18.7299 8.54991 18.71C7.44001 18.52 6.34954 18.2603 5.26964 17.9004C4.46964 17.6404 3.85897 17.0601 3.58897 16.3301C3.31901 15.6101 3.41973 14.7798 3.84971 14.0498L4.9796 12.1699C5.21953 11.76 5.43949 10.9702 5.43956 10.4902V8.62988C5.43962 4.99994 8.38968 2.0598 12.0196 2.0498Z" fill="currentColor" />
      <path d="M14.8297 20.01C14.4097 21.17 13.2997 22 11.9997 22C11.2097 22 10.4297 21.68 9.87969 21.11C9.55969 20.81 9.31969 20.41 9.17969 20C9.30969 20.02 9.43969 20.03 9.57969 20.05C9.80969 20.08 10.0497 20.11 10.2897 20.13C10.8597 20.18 11.4397 20.21 12.0197 20.21C12.5897 20.21 13.1597 20.18 13.7197 20.13C13.9297 20.11 14.1397 20.1 14.3397 20.07C14.4997 20.05 14.6597 20.03 14.8297 20.01Z" fill="currentColor" />
    </Svg>
  ),

  // Settings (4-dot grid variant)
  settings: (props) => (
    <Svg {...props}>
      <path d="M19.07 4.93C18.5 4.36 17.79 3.93 17 3.7V5C17 5.55 16.55 6 16 6C15.45 6 15 5.55 15 5V3.27C14.41 3.1 13.78 3 13.13 3H10.87C10.22 3 9.59 3.1 9 3.27V5C9 5.55 8.55 6 8 6C7.45 6 7 5.55 7 5V3.7C6.21 3.93 5.5 4.36 4.93 4.93C3.93 5.93 3.43 6.43 3.18 7.93L3 9.13V13.13C3 14.62 3.5 15.87 4.5 16.87L4.93 17.3C5.5 17.87 6.21 18.31 7 18.54V17C7 16.45 7.45 16 8 16C8.55 16 9 16.45 9 17V18.91C9.62 19.07 10.27 19.18 10.91 19.18H13.09C13.73 19.18 14.38 19.07 15 18.91V17C15 16.45 15.45 16 16 16C16.55 16 17 16.45 17 17V18.54C17.79 18.31 18.5 17.87 19.07 17.3L19.5 16.87C20.5 15.87 21 14.62 21 13.13V9.13L20.82 7.93C20.57 6.43 20.07 5.93 19.07 4.93ZM12 14.5C10.62 14.5 9.5 13.38 9.5 12C9.5 10.62 10.62 9.5 12 9.5C13.38 9.5 14.5 10.62 14.5 12C14.5 13.38 13.38 14.5 12 14.5Z" fill="currentColor" />
      <path d="M22 22H2C1.45 22 1 21.55 1 21C1 20.45 1.45 20 2 20H22C22.55 20 23 20.45 23 21C23 21.55 22.55 22 22 22Z" fill="currentColor" />
    </Svg>
  ),

  // User
  user: (props) => (
    <Svg {...props}>
      <path d="M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12Z" fill="currentColor" />
      <path d="M12.0002 14.5C6.99016 14.5 2.91016 17.86 2.91016 22C2.91016 22.28 3.13016 22.5 3.41016 22.5H20.5902C20.8702 22.5 21.0902 22.28 21.0902 22C21.0902 17.86 17.0102 14.5 12.0002 14.5Z" fill="currentColor" />
    </Svg>
  ),

  // Sun
  sun: (props) => (
    <svg width={props.size || 20} height={props.size || 20} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <circle cx="12" cy="12" r="5" />
      <line x1="12" y1="1" x2="12" y2="3" />
      <line x1="12" y1="21" x2="12" y2="23" />
      <line x1="4.22" y1="4.22" x2="5.64" y2="5.64" />
      <line x1="18.36" y1="18.36" x2="19.78" y2="19.78" />
      <line x1="1" y1="12" x2="3" y2="12" />
      <line x1="21" y1="12" x2="23" y2="12" />
      <line x1="4.22" y1="19.78" x2="5.64" y2="18.36" />
      <line x1="18.36" y1="5.64" x2="19.78" y2="4.22" />
    </svg>
  ),

  // Moon
  moon: (props) => (
    <svg width={props.size || 20} height={props.size || 20} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
    </svg>
  ),

  // Menu
  menu: (props) => (
    <svg width={props.size || 22} height={props.size || 22} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <line x1="3" y1="12" x2="21" y2="12" />
      <line x1="3" y1="6" x2="21" y2="6" />
      <line x1="3" y1="18" x2="21" y2="18" />
    </svg>
  ),

  // Close X
  x: (props) => (
    <svg width={props.size || 22} height={props.size || 22} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <line x1="18" y1="6" x2="6" y2="18" />
      <line x1="6" y1="6" x2="18" y2="18" />
    </svg>
  ),

  // Search
  search: (props) => (
    <Svg {...props} size={props.size || 18}>
      <path d="M11.5 2C16.7467 2 21 6.25329 21 11.5C21 13.864 20.1338 16.0241 18.7051 17.6865L21.7881 20.7236C22.083 21.0143 22.0865 21.4891 21.7959 21.7842C21.5052 22.0791 21.0304 22.0826 20.7354 21.792L17.6416 18.7441C15.9852 20.1498 13.8426 21 11.5 21C6.25329 21 2 16.7467 2 11.5C2 6.25329 6.25329 2 11.5 2Z" fill="currentColor" />
    </Svg>
  ),

  // Inbox (Support)
  inbox: (props) => (
    <Svg {...props}>
      <path d="M19.5 4H4.5C3.4 4 2.5 4.9 2.5 6V14H7.5C7.5 15.66 8.84 17 10.5 17H13.5C15.16 17 16.5 15.66 16.5 14H21.5V6C21.5 4.9 20.6 4 19.5 4ZM7 10C6.45 10 6 9.55 6 9C6 8.45 6.45 8 7 8H17C17.55 8 18 8.45 18 9C18 9.55 17.55 10 17 10H7Z" fill="currentColor" />
      <path d="M21.5 16H16.5C16.5 17.66 15.16 19 13.5 19H10.5C8.84 19 7.5 17.66 7.5 16H2.5V18C2.5 19.1 3.4 20 4.5 20H19.5C20.6 20 21.5 19.1 21.5 18V16Z" fill="currentColor" />
    </Svg>
  ),

  // Folder (Documents)
  folder: (props) => (
    <Svg {...props}>
      <path d="M21 8.94V18C21 19.66 19.66 21 18 21H6C4.34 21 3 19.66 3 18V8.94H21Z" fill="currentColor" />
      <path d="M21 7.41V7.5H3V6.93C3 5.27 4.34 3.93 6 3.93H8.95C10.06 3.93 10.4 4.29 10.84 4.88L11.84 6.21C12.05 6.49 12.08 6.53 12.48 6.53H17.5C19.16 6.53 20.5 7.41 21 7.41Z" fill="currentColor" />
    </Svg>
  ),

  // Download
  download: (props) => (
    <Svg {...props}>
      <path d="M11.4 16.16L8.16 12.92C7.85 12.61 7.85 12.11 8.16 11.8C8.47 11.49 8.97 11.49 9.28 11.8L11.25 13.78V4C11.25 3.59 11.59 3.25 12 3.25C12.41 3.25 12.75 3.59 12.75 4V13.78L14.72 11.8C15.03 11.49 15.53 11.49 15.84 11.8C15.99 11.95 16.07 12.15 16.07 12.36C16.07 12.57 15.99 12.77 15.84 12.92L12.6 16.16C12.45 16.31 12.25 16.39 12 16.39C11.75 16.39 11.55 16.31 11.4 16.16Z" fill="currentColor" />
      <path d="M19 21H5C3.9 21 3 20.1 3 19V14C3 13.59 3.34 13.25 3.75 13.25C4.16 13.25 4.5 13.59 4.5 14V19C4.5 19.28 4.72 19.5 5 19.5H19C19.28 19.5 19.5 19.28 19.5 19V14C19.5 13.59 19.84 13.25 20.25 13.25C20.66 13.25 21 13.59 21 14V19C21 20.1 20.1 21 19 21Z" fill="currentColor" />
    </Svg>
  ),

  // Send (paper plane)
  send: (props) => (
    <Svg {...props}>
      <path d="M16.14 2.96L7.11 5.96C1.04 7.99 1.04 11.3 7.11 13.32L9.79 14.21L10.68 16.89C12.7 22.96 16.02 22.96 18.04 16.89L21.05 7.87C22.39 3.82 20.19 1.61 16.14 2.96ZM16.46 8.34L12.66 12.16C12.51 12.31 12.32 12.38 12.13 12.38C11.94 12.38 11.75 12.31 11.6 12.16C11.31 11.87 11.31 11.39 11.6 11.1L15.4 7.28C15.69 6.99 16.17 6.99 16.46 7.28C16.75 7.57 16.75 8.05 16.46 8.34Z" fill="currentColor" />
    </Svg>
  ),

  // Copy
  copy: (props) => (
    <Svg {...props}>
      <path d="M16 12.9V17.1C16 20.6 14.6 22 11.1 22H6.9C3.4 22 2 20.6 2 17.1V12.9C2 9.4 3.4 8 6.9 8H11.1C14.6 8 16 9.4 16 12.9Z" fill="currentColor" />
      <path d="M17.0998 2H12.8998C9.81668 2 8.37074 3.09409 8.07422 5.73901C8.06236 5.84477 8.14976 5.93237 8.25618 5.93237H11.0998C15.0998 5.93237 17.9674 8.7999 17.9674 12.7999V15.6436C17.9674 15.75 18.055 15.8374 18.1607 15.8255C20.8056 15.529 21.8998 14.0831 21.8998 11V6.9C21.8998 3.4 20.4998 2 17.0998 2Z" fill="currentColor" />
    </Svg>
  ),
};
